import request from './request'

export const getRunnerList = (params) => {
  return request({
    url: '/admin/runners',
    method: 'get',
    params
  })
}

export const createRunner = (data) => {
  return request({
    url: '/admin/runners',
    method: 'post',
    data
  })
}

export const searchRunnerCandidates = (keyword) => {
  return request({
    url: '/admin/runners/candidates',
    method: 'get',
    params: { keyword }
  })
}

export const getRunnerDetail = (id) => {
  return request({
    url: `/admin/runners/${id}`,
    method: 'get'
  })
}

export const approveRunner = (id) => {
  return request({
    url: `/admin/runners/${id}/approve`,
    method: 'put'
  })
}

export const rejectRunner = (id, remark) => {
  return request({
    url: `/admin/runners/${id}/reject`,
    method: 'put',
    data: { remark }
  })
}

export const updateRunnerStatus = (id, status) => {
  return request({
    url: `/admin/runners/${id}/status`,
    method: 'put',
    data: { status }
  })
}

export const updateRunnerCertStatus = (id, certStatus, certRemark = '') => {
  return request({
    url: `/admin/runners/${id}/cert-status`,
    method: 'put',
    data: { certStatus, certRemark }
  })
}

export const updateRunnerType = (id, runnerTypeId) => {
  return request({
    url: `/admin/runners/${id}/type`,
    method: 'put',
    data: { runnerTypeId }
  })
}

export const updateRunnerReferrer = (id, runnerReferrerId) => {
  return request({
    url: `/admin/runners/${id}/referrer`,
    method: 'put',
    data: { runner_referrer_id: runnerReferrerId }
  })
}

export const updateRunnerMaxOrderCount = (id, maxOrderCount) => {
  return request({
    url: `/admin/runners/${id}/max-order-count`,
    method: 'put',
    data: { maxOrderCount }
  })
}

export const getRunnerReferrerOptions = (params) => {
  return request({
    url: '/admin/runners/referrer-options',
    method: 'get',
    params
  })
}

export const addRunnerCommunity = (id, communityId, startTime = '', endTime = '') => {
  return request({
    url: `/admin/runners/${id}/community`,
    method: 'post',
    data: { communityId, startTime, endTime }
  })
}

export const updateRunnerCommunity = (id, communityId, startTime = '', endTime = '') => {
  return request({
    url: `/admin/runners/${id}/community`,
    method: 'put',
    data: { communityId, startTime, endTime }
  })
}

export const deleteRunnerCommunity = (id, communityId) => {
  return request({
    url: `/admin/runners/${id}/community/${communityId}`,
    method: 'delete'
  })
}
